import Validator from 'validatorjs';
import appStore from '../../state/store';
import { IEsignatureModuleOption, ESIG_MODULE_OPTION_TYPES } from "../../classes/ExternalQuote";
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { VALIDATION } from "../../AppConstants";

export interface IESignatureData {
    insuredName: string,
    options: Array<IEsignatureModuleOption>
}

Validator.register('valid_insured',
    function (value: string | number | boolean, args: string, attribute: string) : boolean {
        const state = appStore.getState();
        console.log(state);
        if (!state.externalQuote) return false;
        const insured = state.externalQuote.insured;
        return (insured.firstName + " " + insured.lastName).toLowerCase() === value.toString().toLowerCase();
    });

const customErrorMessages = {
    "valid_insured": VALIDATION.INVALID_INSURED,
};

export const allFieldsValidation = (data: IESignatureData) => {
    let rules = {
        insuredName: ['required', 'valid_insured']
    };
    const convertedData = { insuredName: data.insuredName };
    if (data.options) {
        for (var i = 0; i < data.options.length; i++) {
            convertedData[data.options[i].label] = data.options[i].value;
            switch (data.options[i].type) {
                case ESIG_MODULE_OPTION_TYPES.YES_NO:
                    rules[data.options[i].label] = ['required'];
                    break;
                case ESIG_MODULE_OPTION_TYPES.PHONE_NUMBER:
                    rules[data.options[i].label] = ['required', 'valid_phone'];
                    break;
            }
        }
    }

    return allFieldsValidationCommon(convertedData, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};